import React from 'react';

const toneMap = {
  dark: {
    base: 'border-white/10 bg-black/25 text-gray-200',
    dot: {
      success: 'bg-emerald-400',
      danger: 'bg-rose-400',
      warning: 'bg-amber-400',
      info: 'bg-cyan-400',
      neutral: 'bg-gray-400',
    },
  },
  light: {
    base: 'border-slate-200 bg-slate-50 text-slate-800',
    dot: {
      success: 'bg-emerald-600',
      danger: 'bg-rose-600',
      warning: 'bg-amber-600',
      info: 'bg-cyan-600',
      neutral: 'bg-slate-500',
    },
  },
};

const MapStatusPill = ({ label, value, variant = 'neutral', tone = 'dark', className = '' }) => {
  const theme = toneMap[tone] || toneMap.dark;
  const dotClass = theme.dot[variant] || theme.dot.neutral;

  return (
    <span className={`inline-flex items-center gap-2 rounded-full border px-2 py-0.5 text-xs font-medium ${theme.base} ${className}`.trim()}>
      <span className={`h-2 w-2 rounded-full ${dotClass}`} />
      <span>{label}: {value}</span>
    </span>
  );
};

export default MapStatusPill;
